import React, {useContext} from 'react';
import './download-panel.scss';
import {DownloadProductOptions} from '../download-product-options';
import {Button} from '../../../button';
import {Text, TextSize} from '../../../text';
import {connect} from 'react-redux';
import {DownloadFormat} from '../download-format';
import {
    updateFormat,
    updateFormatList,
    updateProduct,
    updateProductsList,
} from '../../download-publish-modal-reducer';
import {DownloadMoreOptions} from '../download-more-options';
import {
    DOWNLOAD_BUTTON_CLICKED_CUSTOM_EVENT,
    FILE_SIZE_LARGE,
    getBleed,
    getMarginFlagValue,
    getSelectedFileSize,
    getSelectedFormat,
    getSelectedProduct,
    PHOTO_QUALITY_ID,
    POSTER_QUALITY_ID, PRODUCT_STATUS_DOWNLOADABLE,
    PRODUCT_STATUS_GENERATING,
} from '@Libraries/download-panel-library';
import {ThreeDotsLoader} from '../../../three-dots-loader';
import PropTypes from 'prop-types';
import {updatePublishDropDownState} from '../../../../components/poster-editor/poster-editor-reducer';
import {isMobile} from 'react-device-detect';
import {isMobileWidth} from "@Utils/browser.util";
import {openNewPublishDialog} from "@Libraries/open-new-publish-dialog";

/**
 * Renders the download panel for download publish dialog
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
export class DownloadPanel extends React.Component {

    /**
     *
     * @type {string}
     */
    static FREEBIE_PRODUCT_ID = '0';
    /**
     *
     * @type {string}
     */
    static MODE_DOWNLOAD = 'download';

    /**
     *
     * @type {string}
     */
    static MODE_UPLOAD_TO_DRIVE = 'upload-to-drive';

    /**
     * Constants used in download panel
     * @type {string}
     */
    static MODE_UPLOAD_TO_DROPBOX = 'upload-to-dropbox';
    static DEFAULT_WEB_FILE_QUALITY = 'web';
    static DEFAULT_VIDEO_FILE_QUALITY = 'high';

    //CodeReviewAhsan: Move these genertic properties to a new file-util
    static FILE_FORMAT_JPG = 'jpg';
    static FILE_FORMAT_MP4 = 'mp4';
    static FILE_FORMAT_PNG = 'png';

    //CodeReviewAhsan: I don't see a reason to use redux here. This makes the code unnecessarily complicated and effects readability negatively too. See https://reactjs.org/docs/thinking-in-react.html on how use states and props to solve this.
    //Redux should only be used when distant or too many sibling components require a property which is not the case here because the parent download-panel can have all the common properties as state

    constructor(props) {
        super(props);
        this.state = {
            isCTALoading: false,
        };
        // Setting up values in download modal reducer
        PMW.redux.store.dispatch(updateProductsList(this.props.productsData));
        PMW.redux.store.dispatch(updateProduct(this.#getDefaultProductForUser(this.props.productsData)));
        PMW.redux.store.dispatch(updateFormatList(this.props.formats));
        PMW.redux.store.dispatch(updateFormat(''));
    }

    componentDidUpdate(prevProps) {
        const redirectToPublish = document.querySelector('.js-publish-redirection-from-download');
        if (redirectToPublish) {
            redirectToPublish.addEventListener('click', this.#handleRedirectionToPublish);
        }
    }

    render = () => {

        if (this.props.productsList.length > 0) {
            let isGenerating = this.props.selectedProduct.status === PRODUCT_STATUS_GENERATING;
            return <div className={'download-view'}>
                <div className={'dialog-content'}>
                    <DownloadProductOptions/>
                    <DownloadFormat/>
                    <DownloadMoreOptions expandOptions={false} onMoreOptionsClickCallback={this.#onMoreOptionsBtnClick}/>
                </div>
                <div className={'download-dialog-footer'}>
                    <Button
                        text={isGenerating ? i18next.t('pmwjs_generating') : i18next.t('pmwjs_download')}
                        customClasses={'btn-download medium ' + (isGenerating ? 'btn-disabled disabled' : 'primary btn-primary')}
                        disabled={this.props.selectedProduct.status === PRODUCT_STATUS_GENERATING}
                        onClick={this.#onDownloadBtnClick}
                        isLoading={this.state.isCTALoading}
                    >
                    </Button>
                    <div className={'legal-terms body-xs ' + (PMW.isUserLoggedIn() ? 'hidden' : '')} dangerouslySetInnerHTML={{__html: i18next.t('poster_download_terms_of_use_text', {href: PMW.util.site_url('info/termsofuse')})}}/>
                    {(PMW.showNewPublishDialog && !PMW.isStudent()) ?
                        <div className="flex-center">
                            <Text size={TextSize.XSMALL} className="spacing-p-t-4" val={window.i18next.t('pmwjs_publish_on_download_modal')} dangerouslySetInnerHTML/>
                        </div> : <></>
                    }
                </div>
            </div>;
        } else {
            return <ThreeDotsLoader size={8} distance={8}/>;
        }

    };

    /**
     * Handlers for upload to drive options, to be implemented in phase2
     */
    // #getMarkupForUploadToCloudButton = () => {
    //     return <Button className={"btn-cloud-upload primary btn-primary"}><i className={'icon icon-menu-dots'}/></Button>
    // }
    //
    // /**
    //  * Handler for save to cloud popup
    //  */
    // #onSaveToGoogleDrive = () => {
    //     PMW.processDesign(DownloadPanel.MODE_UPLOAD_TO_DRIVE, getSelectedProduct(), this.#getAdvDownloadOptions());
    // }
    //
    // #onSaveToDropbox = () => {
    //     PMW.processDesign(DownloadPanel.MODE_UPLOAD_TO_DROPBOX, getSelectedProduct(), this.#getAdvDownloadOptions());
    // }

    /**
     * Handler for download btn
     */
    #onDownloadBtnClick = () => {
        //CodeReviewAhsan: I know download handling is not part of this branch but when you do move other things here please make functions like processDesign smaller and more readable.
        this.setState({
            isCTALoading: true,
        }, () => {
            let opts = this.#getAdvDownloadOptions();
            opts.onCheckoutDownloadSuccessCallback = this.#removeDownloadBtnLoading;
            opts.stripeCheckoutCloseCallback = this.#removeDownloadBtnLoading;
            PMW.gtm.trackGA4CustomEvent('DownloadSettings', {[PMW.gtm.GA4_EVENT_PARAM_NAMES.TYPE]: this.#getStringForDownloadSettings()});
            window.dispatchEvent(new CustomEvent(DOWNLOAD_BUTTON_CLICKED_CUSTOM_EVENT));
            PMW.processDesign(DownloadPanel.MODE_DOWNLOAD, getSelectedProduct(), opts);
        });
    };

    #onMoreOptionsBtnClick = () => {
        const selectedProduct = getSelectedProduct();
        if (selectedProduct.downloadUrl && selectedProduct.status === PRODUCT_STATUS_DOWNLOADABLE) {
            if (selectedProduct.needsRegenerationDueToDeletion) {
                let opts = this.#getAdvDownloadOptions();
                opts.showMoreOptionsPageAfterRegeneration = true;
                PMW.processDesign(DownloadPanel.MODE_DOWNLOAD, selectedProduct, opts);
            } else {
                window.open(selectedProduct.downloadUrl, '_blank')
            }
        }
    }

    #handleRedirectionToPublish = (e) => {
        e.stopPropagation();

        if (isMobileWidth() || !PMW.isReactPosterMaker()) {
            openNewPublishDialog(this.props.selectedProduct.hashedId);
        } else {
            window.PMW.redux.store.dispatch(updatePublishDropDownState(true));

        }
        PMW.closeModalDialog('download-publish-dialog');

    };

    #removeDownloadBtnLoading = () => {
        this.setState({isCTALoading: false});
    };

    #getStringForDownloadSettings = () => {
        let settingsStr = '',
            settings = this.#getAdvDownloadOptions();

        if (settings.format) {
            settingsStr += settings.format + '_';
        }

        if (settings.fileSize) {
            settingsStr += settings.fileSize + '_';
        }

        if (settings.bleedValue && parseFloat(settings.bleedValue) > 0) {
            settingsStr += settings.bleedValue + settings.bleedUnits + '_';
        }

        if (settings.hasMargin) {
            settingsStr += 'hasmargin_';
        }

        return settingsStr;
    };

    /**
     * Returns all valid options selected for a product when downloading
     * @returns {{}}
     */
    #getAdvDownloadOptions = () => {
        let advSelectedOpts = {};
        const selectedProduct = getSelectedProduct();

        //Return empty settings if selected product is freebie
        if (selectedProduct.id === DownloadPanel.FREEBIE_PRODUCT_ID) {
            return {};
        }

        const selectedFormat = getSelectedFormat(),
            selectedFileSize = getSelectedFileSize();

        if (selectedProduct.isVideo) {
            advSelectedOpts.format = selectedFormat;
            advSelectedOpts.fileSize = selectedFileSize;
        } else {
            advSelectedOpts.format = selectedFormat;
            advSelectedOpts.fileSize = selectedFileSize;
            advSelectedOpts.hasMargin = getMarginFlagValue() ? 1 : 0;

            const bleedInfo = getBleed();
            advSelectedOpts.bleedValue = bleedInfo.val;
            advSelectedOpts.bleedUnits = bleedInfo.units;
        }

        advSelectedOpts.defaultSettings = this.#isDefaultFormatSelected(selectedProduct, selectedFormat) &&
            (getMarginFlagValue() === false) &&
            (parseFloat(getBleed().val) === 0) &&
            this.#isDefaultSizeSelected(selectedProduct, selectedFileSize);
        if (selectedProduct.posterRenderId) {
            advSelectedOpts.downloadOptionsUrl = PMW.util.site_url('cart/download/' + selectedProduct.posterRenderId);
        }

        return advSelectedOpts;
    };

    #isDefaultSizeSelected = (selectedProduct, selectedSize) => {
        return selectedSize === '' ||
            selectedProduct.isWebDownload && selectedSize === DownloadPanel.DEFAULT_WEB_FILE_QUALITY ||
            selectedProduct.isVideo && selectedSize === DownloadPanel.DEFAULT_VIDEO_FILE_QUALITY ||
            ((parseInt(selectedProduct.id) === POSTER_QUALITY_ID || parseInt(selectedProduct.id) === PHOTO_QUALITY_ID) && selectedSize === FILE_SIZE_LARGE);
    };

    #isDefaultFormatSelected = (selectedProduct, selectedFormat) => {
        return (selectedProduct.isVideo && selectedFormat === DownloadPanel.FILE_FORMAT_MP4) ||
            (!selectedProduct.isVideo && (selectedFormat === DownloadPanel.FILE_FORMAT_JPG || selectedFormat === DownloadPanel.FILE_FORMAT_PNG));
    };

    /**
     * Premium user: First available high-res product
     * Url has 'pr' query param set: First available high-res product
     * PAYG user: Freebie product
     * @param {array.<object>} productList
     * @returns {*|null}
     */
    #getDefaultProductForUser = (productList) => {
        if (this.#showHighResProductAsDefault()) {
            for (let i = 0; i < productList.length; i++) {
                if (parseInt(productList[i].id) === parseInt(this.props.defaultProductId)) {
                    return productList[i];
                }
            }
        }

        return productList.length > 0 ? productList[0] : null;
    };

    /**
     * @returns {boolean}
     */
    #showHighResProductAsDefault = () => {
        const queryParamForHighResProduct = PMW.util.getQueryStringValue('hp'),
            isPremiumUser = PMW.getUserPremiumLevel() > 0;

        return queryParamForHighResProduct === '1' || isPremiumUser;
    };

    /**
     * @param {object} product
     * @returns {boolean}
     */
    #isFreebieProduct = (product) => {
        return product.id === DownloadPanel.FREEBIE_PRODUCT_ID;
    };
}

const mapDownloadPanelStateToProps = state => {
    return {
        productsList: state.downloadPanel.productsList,
        selectedProduct: state.downloadPanel.selectedProduct,
    };
};


DownloadPanel.propTypes = {
    /**
     * Valid download products for the selected design
     */
    productsData: PropTypes.arrayOf(PropTypes.object).isRequired,
    //CodeReviewAhsan: The key of formats is actually the id of product. This means formats should actually be part of product data
    /**
     * List of applicable formats
     */
    formats: PropTypes.object.isRequired,
};
export default connect(mapDownloadPanelStateToProps)(DownloadPanel);
